export { default as SearchAiOutlineIcon } from './SearchAiOutlineIcon';
